import { h, render, Component } from 'preact'

export default class PlayerFilter extends Component {  
  render(props, state) {
    const id = `playerFilter-${ props.filterName }`
    const icon = props.isActive ? <i class='ss-check' /> : ''

    return(
      <li class='player-filter-list-item'>
        <input id={ id } 
               type='checkbox'
               name={ props.filterName }
               class='player-filter-checkbox'
               checked={ props.isActive }
               onChange={ props.onChange }
               data-filter={ props.filterName }/>
        <label for={ id } class='player-filter-label'>{ props.label }</label>
      </li>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/player-filter-component.js